import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Bg from '../../images/bg/hero-bg03.png';
import hImg1 from '../../images/hero1.webp';
import hImg4 from '../../images/shape/hero-linear02.png';
import hImg5 from '../../images/hero5.webp';
import hVideo from '../../images/bg.mp4';

const Hero4 = () => {
    const { t } = useTranslation();

    return (
        <section className="hero hero-style-three pos-rel pt-120 bg_img" style={{ backgroundImage: `url(${Bg})` }}>
            <div className="container">
                <div className="hero_wrap pt-90">
                    <div className="xb-hero text-center">
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1 }}
                        >
                            <div>
                                <h1 className="xb-item--title wow skewIn" data-wow-delay="000ms" data-wow-duration="900ms">
                                    {t('hero.title')}<strong>X</strong>
                                </h1>
                            </div>
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1.4, delay: 0.3 }}
                        >
                            <div>
                                <div className="xb-item--holder wow fadeInUp" data-wow-delay="150ms" data-wow-duration="600ms">
                                    <p className="xb-item--content">{t('hero.subtitle')}</p>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
            <div className="xb-shape">
                {/* LCP image — eager loading with fetchpriority high, explicit dimensions to prevent CLS */}
                <div className="shape shape--one">
                    <img
                        src={hImg1}
                        alt="Orbitronix hero digital architecture illustration"
                        title="Orbitronix Digital Architecture"
                        loading="eager"
                        fetchpriority="high"
                        width="1340"
                        height="222"
                    />
                </div>
                <div className="shape shape--four">
                    <img
                        src={hImg4}
                        alt="Orbitronix geometric linear background element"
                        title="Orbitronix Linear Element"
                        loading="lazy"
                        width="200"
                        height="200"
                    />
                </div>
                <div className="shape shape--five">
                    <img
                        src={hImg5}
                        alt="Orbitronix futuristic platform shape"
                        title="Orbitronix Futuristic Platform"
                        loading="eager"
                        width="670"
                        height="69"
                    />
                </div>
            </div>
            <div className="sc_hero_video">
                <video
                    className="responsive-video"
                    loop
                    muted
                    playsInline
                    autoPlay
                    aria-label="Orbitronix background animation"
                    style={{ width: '100%', height: '100%' }}
                >
                    <source src={hVideo} type="video/mp4" />
                    {/* Captions track — required for accessibility */}
                    <track kind="captions" src="" srcLang="ka" label="Georgian" default />
                </video>
            </div>
            <style>{`
                .hero-style-three .xb-hero .xb-item--holder {
                    padding: 0;
                    text-align: center;
                }
                .hero-style-three .xb-hero .xb-item--title {
                    text-align: center;
                }
                .hero-style-three .xb-hero .xb-item--content {
                    text-align: center;
                }
                @media (max-width: 767px) {
                    .hero-style-three .xb-hero .xb-item--title {
                        letter-spacing: 0.12em;
                    }
                }
            `}</style>
        </section>
    );
};

export default Hero4;